import { createStyles, makeStyles } from "@material-ui/core";
import { useState, cloneElement } from "react";
import { Drawer } from "./drawer";
import { DrawerSection, HeaderTitle, PageSubsection } from "./page_sections";
import { CollapsedSection } from "./collapsed_section";
import Typography from "./typography";
import { JsonContent } from "./static_content";

import config from "../config";

function loadFaqJson() {
  try {
    const region = config.region.toLowerCase(); // e.g., "hkg"
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const faqJson = require(`../content/faq/faq-${region}.json`);
    console.log(faqJson); // Use the loaded JSON
    return faqJson;
  } catch (error) {
    console.error("Failed to load FAQ JSON:", error);
    throw error; // Handle error appropriately
  }
}

type FaqDrawerProps = {
    /** An element that will open the drawer when clicked */
    children: React.ReactElement
}

const useStyles = makeStyles((theme) => createStyles({
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'underline'
    },
}))

export const FaqDrawer = ({ children }: FaqDrawerProps) => {
    const [open, setOpen] = useState(false)
    const classes = useStyles()

    const faqJson = loadFaqJson();

    return (<>
        {cloneElement(children, {
            "data-action": `Open FAQ`,
            onClick: (e: React.MouseEvent) => {
                e.preventDefault()
                setOpen(true)
            }
        })}
        <Drawer
            ModalProps={{
                BackdropProps: {
                    "aria-label": `Close FAQ`,
                }
            }}
            open={open}
            onClose={() => {
                setOpen(false)
            }}>
            <HeaderTitle>
                Frequently Asked Questions
            </HeaderTitle>

            <JsonContent>
                {faqJson}
            </JsonContent>
        </Drawer>
    </>)
}
